import React, { useContext, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { EventSliderCardCss } from "./EventSliderCardV2Css";
import { Col, Row, Image, Button } from "react-bootstrap";
import "./EventSliderCard.css";
import { Link, useNavigate } from "react-router-dom";
import { formatInTimeZone } from "date-fns-tz";
import { TimeZoneContext } from "../../contexts/TimeZoneContext";

interface EventSliderCardI {
  title: string;
  league: string;
  imageUrl: string;
  event: boolean;
  teams?: any[];
  date?: string;
  sport?: string;
  competitionLogo?: string;
  uuid?: string;
  url?: string;
}

const EventSliderCardV2 = (card: EventSliderCardI) => {
  const navigate = useNavigate();
  const [isHovered, setHovered] = useState(false);
  const timeZone = useContext(TimeZoneContext);
  const teams = card?.teams ?? [];

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const cardContentSlider = {
    ...EventSliderCardCss.eventContent,
    opacity: isHovered ? 1 : 0
  };

  return (
    <div
      className="event-wrap-plr slick-slide slick-active active"
      style={EventSliderCardCss.eventWrapMain}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className="event-wrap text-center"
        style={EventSliderCardCss.eventWrap}
      >
        <div
          className="event-img"
          style={{
            background: `url(/${card?.sport}.png)`,
            ...EventSliderCardCss.eventImage
          }}
        >
          <Link
            to={`${card?.url}`}
            tabIndex={0}
            className="main-link"
            style={{
              textDecoration: "none",
              display: "block",
              marginLeft: "7px",
              marginRight: "7px"
            }}
          >
            {card.event ? (
              <Row>
                <Col
                  lg={12}
                  style={{ paddingTop: "6px", paddingBottom: "6px" }}
                >
                  <Image
                    src={card?.competitionLogo ?? "/default-team-logo.svg"}
                    style={{ display: "inline", objectFit: "contain" }}
                    width={"20px"}
                    height={"20px"}
                    onError={(e) => {
                      e.currentTarget.src = "/default-team-logo.svg";
                    }}
                  />
                  <span
                    style={{
                      fontSize: "10px",
                      color: "#fff",
                      textTransform: "uppercase",
                      fontWeight: "bold"
                    }}
                  >
                    {" "}
                    {card?.league?.length <= 17
                      ? card?.league
                      : `${card?.league.slice(0, 16)}...`}
                  </span>
                </Col>
                <Col lg={12}>
                  <span
                    style={{
                      fontSize: "17px",
                      color: "#fff",
                      textTransform: "none",
                      fontWeight: "bold"
                    }}
                  >
                    {card?.title?.length <= 32
                      ? card?.title
                      : `${card?.title.slice(0, 31)}...`}
                  </span>
                </Col>
                <Col lg={12}>
                  <span
                    style={{
                      fontSize: "15px",
                      color: "#fff",
                      textTransform: "none",
                      fontWeight: "normal"
                    }}
                  >
                    {card?.date &&
                      formatInTimeZone(
                        card?.date ?? "",
                        timeZone,
                        "MM/dd/yy hh:mm a"
                      ).toLocaleString()}
                  </span>
                </Col>
              </Row>
            ) : (
              <Image
                src={card.imageUrl}
                width={"100%"}
                style={EventSliderCardCss.img}
              />
            )}
          </Link>
        </div>
        <div
          className="event-content"
          style={{
            ...cardContentSlider,
            marginLeft: !card.event ? "7px" : "0px",
            marginRight: !card.event ? "7px" : "0px"
          }}
        >
          <div
            style={{
              position: "absolute",
              bottom: "0px",
              width: "100%",
              padding: "10px"
            }}
          >
            {card.event ? (
              <>
                <Button
                  className="landing-btn-style"
                  style={EventSliderCardCss.watchNowBtn}
                  onClick={() => navigate(card.url ?? `/events/${card.uuid}`)}
                >
                  Watch Now
                </Button>
              </>
            ) : (
              <div style={{ color: "#fff" }}>
                <h3 className="title">
                  <Link
                    to={`${card?.url}`}
                    style={EventSliderCardCss.eventTitle}
                    tabIndex={0}
                  >
                    {card.title}
                  </Link>
                </h3>
                <div className="event-view-rank">
                  <span>Venue:</span> {card.league}
                  {card.date && <span> | Date: {card.date}</span>}
                </div>
                <div className="event-rating">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="zmdi zmdi-star"></i>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventSliderCardV2;
